import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Constants } from '../../shared/utilities/constants.util';
import { UserPermissions } from '../models/user-permissions.model';

@Injectable()
export class PermissionsService {
	private userPermissions = new BehaviorSubject<UserPermissions>(null);
	userPermissions$ = this.userPermissions.asObservable();

	constructor() {
		this.announceUserPermissions(null);
	}

	announceUserPermissions(value: UserPermissions): void {
		if(value)
		{
            sessionStorage.setItem(Constants.CreatePermissionAreaName, value.createPermissionAreas);
            sessionStorage.setItem(Constants.DeletePermissionAreaName, value.deletePermissionAreas);
            sessionStorage.setItem(Constants.LandingPage, value.landingPage);
			sessionStorage.setItem(Constants.ManageableRoles, value.manageableRoles);
            sessionStorage.setItem(Constants.ReadPermissionAreaName, value.readPermissionAreas);
            sessionStorage.setItem(Constants.RequestAreaName, value.requestAreas);
            sessionStorage.setItem(Constants.UpdatePermissionAreaName, value.updatePermissionAreas);			
		}
		else
		{
			value = {
                createPermissionAreas: sessionStorage.getItem(Constants.CreatePermissionAreaName),
                deletePermissionAreas: sessionStorage.getItem(Constants.DeletePermissionAreaName),
                landingPage: sessionStorage.getItem(Constants.LandingPage),
                manageableRoles: sessionStorage.getItem(Constants.ManageableRoles),
                readPermissionAreas: sessionStorage.getItem(Constants.ReadPermissionAreaName),
                requestAreas: sessionStorage.getItem(Constants.RequestAreaName),
                updatePermissionAreas: sessionStorage.getItem(Constants.UpdatePermissionAreaName)
			};
		}
		
		this.userPermissions.next(value);
	}	

	getUserPermissions(): UserPermissions {
		return this.userPermissions.getValue();
	}
}
